var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import RefreshCcwSVG from './refresh-ccw-01.icon.svg';
export const RefreshCcwIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: RefreshCcwSVG });
};
_react_refresh_temp_1 = RefreshCcwIcon;
$RefreshReg$(_react_refresh_temp_1, "RefreshCcwIcon");
